import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=c38fb4fa"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports